'use client';

import type React from 'react';
import { useEffect, useRef } from 'react';
import isEqual from 'react-fast-compare';
import { animate } from '../animate';
import type { AnimationOptions } from '../types';
import type { AnimationKeyframeWithOptions } from './types';
import { resolveOptions } from './utils/animation-options';

type UseAnimationOptions = {
  enabled?: boolean;
  options?: AnimationOptions;
};

/**
 * @deprecated Use framer-motion's `useAnimation` hook instead.
 */
export const useAnimation = (
  ref: React.RefObject<HTMLElement | null>,
  animation: AnimationKeyframeWithOptions,
  options: UseAnimationOptions = {}
) => {
  const { enabled = true, options: sharedOptions } = options;
  const prevAnimation = useRef(animation);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (ref.current && !isEqual(animation, prevAnimation.current)) {
      // @ts-expect-error FIXME(strictNullChecks)
      animate(ref.current, animation, resolveOptions(sharedOptions, animation));
    }

    prevAnimation.current = animation;
  });
};
